export default function PageFooter() {
  return (
    <div className="page-footer">
      <p>© 2026 Logan Stack</p>
    </div>
  );
}
